<template>
  <div class="credits-bar-container">
    <div class="plan-name-label">{{ planName }}</div>
    <div class="credits-header">
      <span class="credits-label caption">{{ $t('credits.left') }}</span>
      <span class="credits-value">{{ formattedCredits }}</span>
    </div>
    <div class="progress-bar">
      <div class="progress-fill" :style="{ width: creditPercentage + '%' }"></div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { subscriptionPlanMap, plans } from "@/constants/plans";
import { useI18n } from 'vue-i18n';

const store = useStore();
const { locale } = useI18n();

onMounted(() => {
  store.dispatch("fetchRemainingCredits");
  store.dispatch("fetchUserDetails");
});

const credits = computed(() => store.getters.getRemainingCredits);

const maxCredits = computed(() => {
  const userDetails = store.getters.getUserDetails;
  if (!userDetails) return 300;

  const currentPlanName = userDetails.current_subscription_plan || "Freemium";
  const mappedPlanKey = subscriptionPlanMap[currentPlanName];
  const planDetails = plans[mappedPlanKey || "Freemium"];

  return planDetails?.creditsByDefault || 300;
});

const planName = computed(() => {
  const userDetails = store.getters.getUserDetails;
  if (!userDetails) return "Freemium";
  const currentPlanName = userDetails.current_subscription_plan || "Freemium";
  return subscriptionPlanMap[currentPlanName] || "Freemium";
});

const formattedCredits = computed(() => {
  return Number(credits.value)
    .toLocaleString(locale.value, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace(/,/g, " ");
});

const creditPercentage = computed(() => {
  return maxCredits.value > 0 ? (credits.value / maxCredits.value) * 100 : 0;
});
</script>

<style scoped>
.credits-bar-container {
  width: 100%;
}

.plan-name-label {
  font-size: var(--font-size-sm);
  color: var(--color-white-40);
  margin-bottom: var(--spacing-sm);
}

.credits-header {
  display: flex;
  justify-content: space-between;
  color: var(--color-white-60);
  margin-bottom: var(--spacing-xl);
}

.credits-label {
  color: var(--color-white-60);
}

.credits-value {
  color: var(--color-white);
}

.progress-bar {
  width: 100%;
  height: 0.2rem;
  background: var(--color-white-20);
  border-radius: var(--border-radius-xs);
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: var(--gradient-primary);
  border-radius: var(--border-radius-xs);
  transition: width var(--transition-normal);
}
</style>
